import { defineFcm } from '../shared/factory';

export const FCM_AMBASSADOR_POST_CREATE_FLOW = defineFcm('ambassador_post_create_flow')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		// The Change Ambassadors program is a single global cohort, so a per-country/per-locale
		// override would only add admin rows the consumer ignores.
		supportedGroups: { global: true },
		context: 'Post-Start A Petition Ambassador Onboarding',
		description:
			'Controls whether petitions published through the Change Ambassadors flow land on the dedicated ambassador post-publish page instead of the standard starter onboarding flow. When off, ambassadors fall back to the standard flow.',
	});
